import React, { useEffect } from "react"
import "../index.scss"

import Layout from "src/components/layout"
import Head from "../../components/Head"

import Button from "../../components/common/Button/Button"
import { graphql, useStaticQuery } from "gatsby"
import {useTranslation} from "react-i18next"
import BRANDS from "../../brands";
import COUNTRY from "../../constants"

const AppMain = ({ location }) => {

  const { t, i18n } = useTranslation()
  useEffect(() => {
    i18n.changeLanguage(COUNTRY.en_am)
  }, [i18n])

  const data = useStaticQuery(graphql`
    query appPageClientsEnAm {
      site {
        siteMetadata {
          countries {
            am {
              hotLine {
                tel
                title
                telephone
                telephoneTitle
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Layout
      hotLine={data.site.siteMetadata.countries.am.hotLine}
      location={location}
      country="en_am"
    >
      <Head
        lang="en_am"
        title={t('head.app.title', { brand: BRANDS.SPORTBENEFIT.appTitle } )}
        slug="/app/"
        apps={true}
      />
      <section className="main-page">
        <div className="buttons-wrapper">
          <a
            className="button blue"
            href="https://play.google.com/store/apps/details?id=by.allsports.holder"
          >
            { t("app.android.title") }
          </a>
        </div>
        <div className="buttons-wrapper">
          <a
            className="button blue"
            href="https://appgallery.huawei.com/app/C104288727"
          >
            { t("app.huawei.title") }
          </a>
        </div>
        <div className="buttons-wrapper">
          <a
            className="button blue"
            href="https://apps.apple.com/us/app/allsports/id1555419187"
          >
            { t("app.ios.title") }
          </a>
        </div>
        <form
          method="get"
          action={
            "media/allsports-release.apk?" +
            "created=" +
            new Date().toDateString()
          }
        >
          <Button color="blue" type="submit">
            { t("app.android.from_site_title") }
          </Button>
        </form>
      </section>
    </Layout>
  )
}

export default AppMain
